interface BadgeProps {
  label: string;
  className?: string;
}

export default function Badge({ label, className = 'badge-neutral' }: BadgeProps) {
  return <span className={`badge ${className}`}>{label.replace(/_/g, ' ')}</span>;
}
